import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigninComponent } from './signin/signin.component';
import { AccountService } from './shared/services/account.service';
import { SharedModule } from '@app/shared/shared.module';
import { ForgotPasswordComponent } from './shared/components/forgot-password/forgot-password.component';
import { ContactAdminComponent } from './shared/components/contact-admin/contact-admin.component';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { AutoLogoutComponent } from './auto-logout/auto-logout.component';
import { SsoCallbackComponent } from './sso-callback/sso-callback.component';

@NgModule({
	declarations: [SigninComponent, ForgotPasswordComponent, ContactAdminComponent, AutoLoginComponent, AutoLogoutComponent, SsoCallbackComponent],
	imports: [CommonModule, SharedModule],
	exports: [],
	providers: [AccountService],
})
export class AccountModule {}
